var VERBOSE = false;
/**
 * Incremental progress array generator
 */
var ProgressIncrementer = /** @class */ (function () {
    function ProgressIncrementer(length, interpolationCache, valuesPerElement) {
        if (length === void 0) { length = 1; }
        if (interpolationCache === void 0) { interpolationCache = null; }
        if (valuesPerElement === void 0) { valuesPerElement = 1; }
        this._progress = 0.0;
        this._duration = 1.0;
        this._offset = 0.5;
        this._revert = false;
        this._valuesPerElement = 1; // WARNING: hardcoded to 1 or 2
        /**
         * True if the internal state has changed since the last query
         */
        this._dirty = false;
        VERBOSE && console.log('create ProgressIncrementer', length);
        this._length = length;
        this._interpolationCache = interpolationCache;
        this._valuesPerElement = valuesPerElement;
        this._build();
    }
    Object.defineProperty(ProgressIncrementer.prototype, "valuesPerElement", {
        get: function () {
            return this._valuesPerElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProgressIncrementer.prototype, "revert", {
        get: function () {
            return this._revert;
        },
        /**
         * Whether the array should be reversed. Changing this property will rebuilt the internal state and set the object
         * as dirty.
         */
        set: function (value) {
            VERBOSE && console.log('setting revert from', this._revert, 'to', value);
            if (value === this._revert) {
                return;
            }
            this._revert = value;
            this._build();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProgressIncrementer.prototype, "length", {
        get: function () {
            return this._length;
        },
        /**
         * The length of the array to generate
         */
        set: function (value) {
            VERBOSE && console.log('setting length from', this._length, 'to', value);
            if (value === this._length) {
                return;
            }
            this._length = value;
            this._build();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProgressIncrementer.prototype, "progress", {
        get: function () {
            return this._progress;
        },
        /**
         * The current progress of the incrementer
         */
        set: function (value) {
            if (value === this._progress) {
                return;
            }
            // console.log('set progress', value);
            this._progress = value;
            this._dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProgressIncrementer.prototype, "offset", {
        get: function () {
            return this._offset;
        },
        /**
         * The offset of the incrementer
         */
        set: function (value) {
            if (value === this._offset) {
                return;
            }
            this._offset = value;
            this._build();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProgressIncrementer.prototype, "duration", {
        get: function () {
            return this._duration;
        },
        /**
         * The duration of the incrementer
         */
        set: function (value) {
            if (value === this._duration) {
                return;
            }
            this._duration = value;
            this._build();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProgressIncrementer.prototype, "array", {
        /**
         * The array of values
         */
        get: function () {
            return this._array;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProgressIncrementer.prototype, "start", {
        /**
         * The start values of the array
         */
        get: function () {
            return this._start;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProgressIncrementer.prototype, "end", {
        /**
         * The end values of the array
         */
        get: function () {
            return this._end;
        },
        enumerable: false,
        configurable: true
    });
    ProgressIncrementer.prototype._build = function () {
        VERBOSE && console.log('_build');
        this._buildArrays();
        this._calculateRange();
        this._dirty = true;
    };
    ProgressIncrementer.prototype._buildArrays = function () {
        if (!this.array || this.array.length !== this.length * this.valuesPerElement) {
            this._array = new Float32Array(this.length * this.valuesPerElement);
            this._start = new Float32Array(this.length);
            this._end = new Float32Array(this.length);
        }
    };
    ProgressIncrementer.prototype._calculateRange = function () {
        var _this = this;
        // console.log('calculate range', this.offset, this.duration);
        var start = this.start.map(function (_, index) { return index * _this.offset; });
        var end = start.map(function (value) { return value + _this.duration; });
        var lastValue = end[end.length - 1];
        var normalizedStart = start.map(function (value) { return value / lastValue; });
        var normalizedEnd = end.map(function (value) { return value / lastValue; });
        if (this.revert) {
            normalizedStart.reverse();
            normalizedEnd.reverse();
        }
        this._start = normalizedStart;
        this._end = normalizedEnd;
    };
    ProgressIncrementer.prototype.update = function () {
        VERBOSE && console.log('update');
        if (!this._dirty) {
            return;
        }
        this._calculateProgress();
    };
    ProgressIncrementer.prototype._calculateProgress = function () {
        // console.log('calculate progress', this.progress);
        for (var i = 0; i < this.start.length; i++) {
            var value = this._calculateProgressForIndex(i);
            if (this._interpolationCache) {
                value = this._interpolationCache.getCachedValue(value);
            }
            if (this.valuesPerElement === 1) {
                this.array[i] = value;
            }
            else if (this.valuesPerElement === 2) {
                this.array[(i * 2)] = value;
                this.array[(i * 2) + 1] = value;
            }
        }
        this._dirty = false;
    };
    ProgressIncrementer.prototype._calculateProgressForIndex = function (index) {
        if (this.progress >= this._end[index]) {
            return 1.0;
        }
        else if (this.progress >= this._start[index] && this.progress <= this._end[index]) {
            var duration = this._end[index] - this._start[index];
            var localProgress = this.progress - this._start[index];
            return localProgress / duration;
        }
        else {
            return 0.0;
        }
    };
    return ProgressIncrementer;
}());
export { ProgressIncrementer };
